export default {
  state: {
    path: undefined,
    fullPath: undefined,
    params: undefined,
    query: undefined,
    name: undefined
  },
  mutations: {
    "route/ROUTE_CHANGED" (state, data) {
      state.path = data.to.path
      state.fullPath = data.to.fullPath
      state.params = data.to.params
      state.query = data.to.query
      state.name = data.to.name
    },
    updateSearchTerm(state, newSearch) {
      state.params.search_term = newSearch
    }
  }
}
